import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../apis/store";
import { toGetExternalPrograms } from "../../../apis/actions/programs.actions";
import ServiceProgramCard from "../../../biblio/Cards/ServiceProgramCard";
import { Col, Row } from "antd";

const OtherPrograms = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { externalProgramDetails } = useSelector(
    (state: RootState) => state?.programs
  );

  const { items: externalPrograms } = useSelector(
    (state: RootState) => state?.programs.externalPrograms
  );

  const [filteredProgram, setFilteredProgram] =
    useState<any[]>(externalPrograms);

  useEffect(() => {
    dispatch(toGetExternalPrograms());
  }, [dispatch]);

  useEffect(() => {
    setFilteredProgram(
      externalPrograms.filter(
        (program: any) => program.id !== externalProgramDetails?.id
      )
    );
  }, [externalPrograms, externalProgramDetails]);

  return (
    <div className="takaful--card-other-container">
      <div className="takaful--card-other-title">
        <span>برامج أخرى</span>
      </div>

      <div className="takaful--cases-section">
        <div className="takaful--cases" style={{ marginTop: "10rem" }}>
          <Row gutter={[16, 48]}>
            {filteredProgram.length > 0 &&
              filteredProgram.slice(0, 3).map((project: any, index: number) => (
                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                  <ServiceProgramCard
                    card={project}
                    index={index}
                    type="external"
                  />
                </Col>
              ))}
          </Row>
        </div>
      </div>
    </div>
  );
};

export default OtherPrograms;
